import { render, staticRenderFns } from "./CreateURL.vue?vue&type=template&id=6006ae4f&"
import script from "./CreateURL.vue?vue&type=script&lang=js&"
export * from "./CreateURL.vue?vue&type=script&lang=js&"
import style0 from "./CreateURL.vue?vue&type=style&index=0&id=6006ae4f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports